<template>
  <div v-if="modelType" class="flex p-4 font-roboto text-new-black shadow-none">
    <div
      class="grid w-full gap-x-[60px] max-lg:grid-flow-row lg:grid-cols-[318px,1fr]"
    >
      <div class="flex h-fit items-center">
        <MainPageCardsReworkedTeacherContentSrcIcon
          v-if="data?.entity_source && data.entity_source.id !== 2"
          :link="data.entity_source.url"
          class="mr-1.5 size-4 shrink-0"
        />
        <div class="text-[16px] font-medium leading-[22px]">
          {{ beautyRange }}
        </div>
      </div>
      <div class="text-[14px] leading-[17px] max-lg:mt-3">
        {{ data.description }}
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
    require: true,
  },
});

const { beautyRange } = useFormatEntityDate(props.data);

const modelType = computed(() => props.data?.model_type);
</script>
